import { Component, OnInit } from '@angular/core';
import { LoginService } from 'src/app/services/login/login.service';
import { AuthStore } from 'src/app/services/auth.store';
import { Usuario } from 'src/app/models/usuario';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit {
  private allAppPages = [
    { title: 'Escalas', url: '/scale', icon: 'apps', requiredRole: null },
    {
      title: 'Colaboradores',
      url: '/collaborators',
      icon: 'people',
      requiredRole: 'USER_ADMIN',
    },
    {
      title: 'Locais',
      url: '/locations',
      icon: 'Location',
      requiredRole: 'USER_ADMIN',
    },
    {
      title: 'Empresas',
      url: '/empresa',
      icon: 'business',
      requiredRole: 'USER_ADMIN',
    },
  ];

  public appPages: any[] = [];
  public currentUser: Usuario = {} as Usuario;
  public isAdmin = false;

  constructor(private login: LoginService, private authStore: AuthStore) {}

  ngOnInit() {
    this.currentUser = this.authStore.getUser();
    this.isAdmin = this.hasRole('USER_ADMIN');
    this.filterMenuItems();

    // Subscribe to user changes
    this.authStore.user$.subscribe((user) => {
      this.currentUser = user;
      this.isAdmin = this.hasRole('USER_ADMIN');
      this.filterMenuItems();
    });
  }

  private hasRole(role: string): boolean {
    return (
      !!this.currentUser &&
      this.currentUser.roles! &&
      this.currentUser?.roles.includes(role)
    );
  }

  private filterMenuItems() {
    this.appPages = this.allAppPages.filter(
      (page) => page.requiredRole === null || this.hasRole(page.requiredRole)
    );
  }

  logout() {
    this.login.logout();
  }
}
